import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CompanyInfo, Internship } from '../../shared/dto/models-dto';


interface DialogData {
  internship: Internship;
  company: CompanyInfo;
}

@Component({
  selector: 'app-internship-details',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './internship-details.component.html',
  styleUrls: ['./internship-details.component.css']
})
export class InternshipDetailsComponent {
  internship: Internship;
  company: CompanyInfo;

  constructor(
    public dialogRef: MatDialogRef<InternshipDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.internship = data.internship;
    this.company = data.company;
  }

  onClose(): void {
    this.dialogRef.close();
  }

  getAdditionalDetails(): Array<{ key: string; value: any }> {
    const standardKeys = ['id', 'title', 'position', 'department', 'country', 'city'];
    return Object.entries(this.internship)
      .filter(([key]) => !standardKeys.includes(key))
      .map(([key, value]) => ({ key, value }));
  }

  formatKey(key: string): string {
    // Converte camelCase in Title Case
    return key
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, str => str.toUpperCase())
      .trim();
  }
}
